import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import { Wrapper, StyledContainer, Content, Img } from './styles';

const HeroBanner = ({ data }) => {
  if (!data) return null;

  const {
    headingHtml,
    subheadingHtml,
    bannerCTAText,
    bannerCTA: { url: href },
    mobileHeroImage: { altTag },
    heroImage,
    mobileHeroImage,
    ctaType,
    ariaLabel,
    queryString,
  } = data;

  return (
    <Wrapper id="hero" background={heroImage ? heroImage.url : null}>
      <StyledContainer className={['auto-margin']}>
        <Content>
          {ReactHtmlParser(headingHtml)}
          {ReactHtmlParser(subheadingHtml)}
          <Link
            className={`${ctaType} auto-size`}
            to={href}
            ariaLabel={ariaLabel}
            queryString={queryString}
          >
            {bannerCTAText}
          </Link>
        </Content>
        <Img
          src={
            mobileHeroImage
              ? { publicURL: mobileHeroImage.url }
              : { publicURL: heroImage.url }
          }
          alt={altTag}
        />
      </StyledContainer>
    </Wrapper>
  );
};

HeroBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

HeroBanner.defaultProps = {};

export default HeroBanner;
